export default __webpack_public_path__ + "static/media/15th_EPE_Result_2.5fc8bb11.pdf";